// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"167":"component---src-pages-channels-tsx","218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"167":"4ce736f14790d97ca57e","218":"a1f64e4ff7fe5429ce97","691":"82aae372c91b216aed12"}[chunkId] + ".js";
};